import classNames from "classnames";
import React from "react";
import { AppButton } from "../../../../../Generic/AppButton";

const yesNoPossibleAnswers = ["Yes", "No"];
export interface Props {
  answer: string | null;
  onQuestionClick: (answer: string) => void;
}

const VBPYesNoQuestion = (props: Props) => {
  return (
    <div className="VBPYesNoQuestion">
      {yesNoPossibleAnswers.map((answer: string, index: number) => {
        return (
          <AppButton
            key={index}
            variant={"outline"}
            textColor="primary"
            onClick={() => props.onQuestionClick(answer)}
            className={classNames({
              VBPYesNoQuestion__answers_answer: true,
              VBPYesNoQuestion__answers_selectedAnswer: props.answer === answer,
            })}
          >
            {answer}
          </AppButton>
        );
      })}
    </div>
  );
};

export default React.memo(VBPYesNoQuestion);
